export class Factory {
	id: number;
  number: number;
  description: string;
  companyId: number;
}
